import { api } from "@king-ict/eupisi-ui/utils";

import { TownCodeBook } from "../../models/Town";

const townsUrlPrefix: string = "towns";

export const searchTowns = async (search: string, municipalityId?: number, countyId?: number) => {
    let url = `${townsUrlPrefix}?search=${search}`;
    if (countyId){
        url += `&countyId=${countyId}`;
    }

    if (municipalityId){
        url += `&municipalityId=${municipalityId}`;
    }

    return api.get(url) as Promise<TownCodeBook[]>
}

export const getTownById = async (id: number) => {
    return api.get(
        `${townsUrlPrefix}/${id}`
    ) as Promise<TownCodeBook>
}